export const headBody7 = {
    "bone_controllers": [
        {
            "name": "legs_length_long",
            "value": 0.4
        },
        {
            "name": "waist_length_long",
            "value": 0.4
        },
        {
            "name": "neck_length_long",
            "value": 0.1
        },
        {
            "name": "head_size_small",
            "value": 0.3
        },
        {
            "name": "arms_length_long",
            "value": 0.6
        },
        {
            "name": "waist_thickness_thick",
            "value": 0.3
        },
        {
            "name": "arms_thickness_thick",
            "value": 0.15
        },
        {
            "name": "legs_thickness_thick",
            "value": 0.2
        }
    ],
}